import React from 'react'
import SlackInstall from "./SlackInstall";

const SlackInstallDenied = () => <SlackInstall notInstalled />

export default SlackInstallDenied



// WEBPACK FOOTER //
// ./src/components/SlackInstallDenied.jsx